/*! bxs-vue-ui v4.0.1 */
import { g as getBuiltIn } from './es.array.join.js';

var html = getBuiltIn('document', 'documentElement');

export { html as h };
